import React from 'react';
import Link from '~/App/shared/components/Link';
import Media from '~/App/shared/components/Media';
import styled from 'styled-components';
import {
  mq,
  Title,
  BodyText,
  theme,
  Subtitle,
  Caption
} from '@kvdbil/components';
import { AboutAreaRecord } from '~/config/generated/graphql';
import StructuredText, {
  StructuredTextProps
} from '~/App/components/DatoCMS/StructuredText';
import { DatoTitleTag } from '~/App/shared/interfaces/datoCMS';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${theme.colors.background.light};
  width: 100%;
  padding: 2rem;

  ${mq('tablet')} {
    display: flex;
  }

  ${mq(null, 'mobileL')} {
    padding: 2rem 1rem;
  }
`;

const BenefitButtons = styled.ul`
  display: flex;
  gap: 1rem;
  margin: 1rem 0 2rem;
  width: 100%;

  ${mq(null, 'tablet')} {
    flex-direction: column;
  }
`;

const StyledListItem = styled.li`
  display: flex;
  flex: 1;
  overflow: hidden;

  p {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
`;

const StyledLink = styled(Link)`
  border: 2px solid ${theme.colors.background.gray};
  border-radius: 0.5rem;
  color: ${theme.colors.text.dark};
  padding: 1rem;
  text-align: center;
  width: 100%;
`;

const StyledFlex = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
  ${mq(null, 'tablet')} {
    flex-direction: column;
  }
`;

const BenefitIconWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0.25rem 0;
  gap: 1rem;

  ${mq(null, 'mobileL')} {
    gap: 0.5rem;
    flex-direction: column;
  }
`;

const BenefitMediaContainer = styled.div`
  width: 4rem;
`;

const AboutArea = ({
  title,
  paragraph,
  linkList,
  iconsWithText
}: AboutAreaRecord) => {
  return (
    <Container>
      <div>
        <Title as={(title?.[0]?.tag ?? 'h2') as DatoTitleTag}>
          {title?.[0]?.text}
        </Title>
        <StructuredText data={paragraph as StructuredTextProps['data']} />
      </div>
      <BenefitButtons>
        {linkList.map(linkItem => {
          const { text, url, caption } = linkItem;
          return (
            <StyledListItem key={text}>
              <StyledLink to={url ?? ''}>
                <Subtitle>{text}</Subtitle>
                {caption && <Caption>{caption}</Caption>}
              </StyledLink>
            </StyledListItem>
          );
        })}
      </BenefitButtons>
      <StyledFlex>
        {iconsWithText.map(({ text, imageIcon }, i) => (
          <BenefitIconWrapper key={i}>
            <BenefitMediaContainer>
              <Media
                width={75}
                src={imageIcon?.icon?.url ?? ''}
                alt={imageIcon?.icon?.alt ?? ''}
                imageType="THUMBNAIL"
                ratio={5 / 3}
              />
            </BenefitMediaContainer>
            <BodyText as="span">{text}</BodyText>
          </BenefitIconWrapper>
        ))}
      </StyledFlex>
    </Container>
  );
};

export default AboutArea;
